import {FC} from 'react';
import clsx from 'clsx';
import ArrSectionCard, {
  ArrSectionCardProps,
} from '../../../../common/arr-accordion-v2/ArrSectionCard';
import './CaseContextViewSectionCard.scss';

export type CaseContextViewSectionCardProps = Omit<
  ArrSectionCardProps,
  'mode' | 'showAddButton' | 'showDeleteButton'
>;

interface CaseContextViewSectionCardComponent
  extends FC<CaseContextViewSectionCardProps> {
  Row: typeof ArrSectionCard.Row;
  Item: typeof ArrSectionCard.Item;
}

/**
 * Case Context view-mode section card.
 * Wraps ArrSectionCard with view defaults; view typography/layout live in
 * CaseContextViewSectionCard.scss (not ArrSectionCard.scss).
 */
const CaseContextViewSectionCard: CaseContextViewSectionCardComponent = ({
  className,
  ...rest
}) => (
  <ArrSectionCard
    {...rest}
    mode="view"
    showAddButton={false}
    showDeleteButton={false}
    className={clsx('case-context-view-section-card', className)}
  />
);

CaseContextViewSectionCard.Row = ArrSectionCard.Row;
CaseContextViewSectionCard.Item = ArrSectionCard.Item;

export default CaseContextViewSectionCard;
